import axios from "axios";
// import store from '../store';

function errorHandler(error, reject) {
  console.log(error);
  if (error.response && error.response.data) {
    reject(error.response.data);
  } else {
    reject(error);
  }
}

export default {
  insert(data) {
    return new Promise(async (resolve, reject) => {
      try {
        await axios.post("/clients", data);
        resolve();
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  remove(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const resp = await axios.delete(
          `/clients/${encodeURIComponent(obj.compcode)}`
        );
        resolve(resp);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
};
